import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import arrowleft from "../../../icons/arrowleft.png";
import arrowright from "../../../icons/arrowright.png";
import dashboard from "../../../icons/dashboard.png";
import halfcub from "../../../icons/halfcub.png";
import drop from "../../../icons/drop.png";
import handdrop from "../../../icons/handdrop.png";
import flag from "../../../icons/Flag.png";
import compiling from "../../../icons/Compiling.png";
import cub4 from "../../../icons/cub4.png";
import logo from "../../../icons/logo.jpg";
import sfrico from "../../../icons/aaa.png";
import { Layout, Menu } from "antd";
import { Dropdown, Space } from "antd";
import {
  DownOutlined,
  UserOutlined,
  LogoutOutlined,
  CalculatorOutlined,
} from "@ant-design/icons";
import { exit } from "../../../components/functions/Exit";

const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const sideMenu = [
  getItem(
    <NavLink to="/">Bosh sahifa</NavLink>,
    "1",
    <span role="img" className="sidebar-icon">
      <img src={dashboard} alt="404" />
    </span>
  ),
  getItem(<hr style={{ borderColor: "#eee" }} />, "just-label"),

  getItem(
    <NavLink to="aqllisuv">Aqlli suv</NavLink>,
    "5",
    <span role="img" className="sidebar-icon">
      <img src={drop} alt="404" />
    </span>
  ),
  //   getItem(
  //     <NavLink to="suvdanfoydalanish">Suvdan foydalanish</NavLink>,
  //     "10",
  //     <span role="img" className="sidebar-icon">
  //       <img src={handdrop} alt="404" />
  //     </span>
  //   ),
  //   getItem(
  //     "Sug’orish",
  //     "15",
  //     <span role="img" className="sidebar-icon">
  //       <img src={halfcub} alt="404" />
  //     </span>,
  //     [
  //       getItem(<NavLink to="vegetatsiya">- Vegetatsiya</NavLink>, "16"),
  //       getItem(<NavLink to="novegetatsiya">- Novegetatsiya</NavLink>, "17"),
  //     ]
  //   ),
  // getItem('Limit', '21', <span role="img" className="sidebar-icon"><img src={halfcub} alt="404" /></span>,[
  //     getItem(<NavLink to="/limit/ptn">- 1-ilova</NavLink>, '22'),
  //     getItem(<NavLink to="/limit/manbalar">- 2-ilova</NavLink>, '23'),
  //     getItem(<NavLink to="/limit/daryolar">- 3-ilova</NavLink>, '24'),
  // ]),
  getItem(
    "Sfr",
    "25",
    <span role="img" className="sidebar-icon">
      <img src={sfrico} alt="404" />
    </span>,
    [
      getItem(
        <NavLink to="/sfr/gidromodul/new">Gidromodul bo'yicha</NavLink>,
        "26"
      ),
      getItem(<NavLink to="/sfr/fao">FAO bo'yicha</NavLink>, "27"),
    ]
  ),
];

const items = [
  getItem("Profil", "1", <UserOutlined style={{ color: "#6993FF" }} />),
  {
    key: "2",
    label: (
      <span
        className=""
        style={{ fontSize: "13px" }}
        rel="noopener noreferrer"
        onClick={() => exit()}
      >
        Chiqish
      </span>
    ),
    icon: <LogoutOutlined style={{ color: "#db0909" }} />,
  },
];

const MainLayout = ({ date, setDate }) => {
  const location = useLocation();
  const [ldate, setLdate] = useState(date);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout>
      <Sider width={265} trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          {collapsed ? "SM" : "SMARTWATER"}
          {React.createElement(
            collapsed
              ? () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowright} alt="404" />
                  </span>
                )
              : () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowleft} alt="404" />
                  </span>
                )
          )}
        </div>

        <Menu
          className="sidebar-menu upper"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={sideMenu}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="site-layout-background top-menu"
          style={{ padding: 0, height: "64px" }}
          mode="horizontal"
        >
          <div className="ps-3 d-flex">
            <div>
              <img height="70%" src={logo} alt="404" />
            </div>

            <div className="ps-2 d-flex align-items-center">
              <h4
                className="m-0 text-uppercase"
                style={{ lineHeight: "20px", color: "#656363" }}
              >
                {JSON.parse(localStorage.getItem("sw_user")).district}
              </h4>
            </div>
          </div>

          <div className="dropdown-style">
            <ul>
              {location.pathname === "/" ? (
                <li className="d-flex align-items-center">
                  <div className="d-flex" style={{ height: "36px" }}>
                    <input
                      className="form-control form-control-sm"
                      type="date"
                      onChange={(e) => setLdate(e.target.value)}
                      value={ldate}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-outline-success btn-sm"
                      type="submit"
                      onClick={() => setDate(ldate)}
                    >
                      Ok
                    </button>
                  </div>
                </li>
              ) : null}

              <li>
                <img src={compiling} alt="404" />
              </li>

              <li>
                <img src={cub4} alt="404" />
              </li>

              <li>
                <img src={flag} alt="404" />
              </li>
            </ul>

            <Dropdown menu={{ items }}>
              <button
                className="btn"
                style={{ border: "unset" }}
                onClick={(e) => e.preventDefault()}
              >
                <Space className="dropdown-btn">
                  {JSON.parse(localStorage.getItem("sw_user")).fio}

                  <span style={{ position: "absolute", top: "20px" }}>
                    <DownOutlined />
                  </span>
                </Space>
              </button>
            </Dropdown>
          </div>
        </Header>

        <Content className="site-layout-background">
          <Outlet context={[collapsed]} />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
